<template>
  <v-container grid-list-md :class="['pa-0']">
    <v-layout row wrap>
      <v-flex xs6>
        <h1 :class="['headline', 'font-weight-light', 'mb-2']" v-html="title" />
      </v-flex>
      <v-flex xs6 :class="['hidden-md-and-down']">
        <v-breadcrumbs divider=">" :class="['pa-0', 'ma-0', 'mt-2', 'justify-end']" :hidden="$route.path === '/'">
          <v-breadcrumbs-item v-for="(item, index) in breadcrumbs" :key="index" :disabled="false" :to="item.href" :title="item.text">{{ item.text }}</v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-flex>
      <v-flex xs12>
        <p :class="['body-1', 'font-weight-light']" v-html="info" />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import lang from '../helpers/lang'
import breadcrumbsLang from '../helpers/breadcrumbs-lang'
import events from '../helpers/events'
import methods from '../helpers/methods'

export default {
  name: 'PageHeader',
  mixins: [
    methods
  ],
  data () {
    return {
      lang,
      breadcrumbsLang,
      breadcrumbs: []
    }
  },
  props: {
    /**
     * Component title
     * @string
     */
    title: {
      type: String,
      required: false,
      default: null
    },
    /**
     * Component subtitle/paragraph
     * @string
     */
    info: {
      type: String,
      required: false,
      default: null
    }
  },
  mounted () {
    this.$root.$on(events.route, () => {
      this.renderHeader()
    })
  },
  beforeDestroy () {
    this.$root.$off(events.route)
  },
  methods: {
    /**
     * Prepare the data and render the component
     * @method renderHeader
     * @return {void}
     */
    renderHeader () {
      let path = window.location.href.split('://')[1].split('/')
      const root = this.$root
      const genres = root.genres
      const regions = root.regions
      const genresList = {}
      const regionsList = {}
      const breadcrumbs = []
      const breadcrumbsLang = this.breadcrumbsLang
      genres.forEach(genre => {
        genresList[genre.id] = genre.label
      })
      regions.forEach(region => {
        regionsList[region.id] = region.label.cyrillic
      })
      path.shift()
      path.unshift('/')
      path.forEach((item, index) => {
        path[index] = (path[index - 1] ? path[index - 1] + '/' + decodeURIComponent(item) : decodeURIComponent(item)).replace(/\/\//, '/')
      })
      path.forEach((item, index) => {
        let text = index === 0 ? item : item.split('/').pop()
        if (!genresList[text]) {
          text = breadcrumbsLang[text] || text
        }
        if (genresList[text]) {
          text = genresList[text]
        }
        if (regionsList[text]) {
          text = regionsList[text]
        }
        breadcrumbs.push({
          text,
          href: item
        })
      })
      breadcrumbs[0].text = breadcrumbsLang.start
      this.breadcrumbs = breadcrumbs
      this.setBreadcrumbsColor()
    }
  }
}
</script>
<style>
.v-breadcrumbs .v-breadcrumbs__item--disabled
{
  pointer-events: all !important;
}

.v-breadcrumbs > .v-breadcrumbs__divider:only-of-type
{
  border: solid 1px red;
}
</style>



// WEBPACK FOOTER //
// src/components/page-header.vue